"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
// styled components, if it grows put in a sibling file
var HeaderDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 8px;\n  & > div {\n    display: inline;\n    margin-right: 8px;\n    & > * {\n      display: inline;\n    }\n  }\n  & > .tk-link.toggle {\n    margin-left: 8px;\n    text-decoration: none;\n    display: inline;\n  }\n  & > .tk-icon-top {\n    &::before {\n      transition: transform 300ms ease-in-out;\n    }\n    &.collapsed::before {\n      transform: rotate(180deg);\n    }\n    cursor: pointer;\n  }\n"], ["\n  margin-bottom: 8px;\n  & > div {\n    display: inline;\n    margin-right: 8px;\n    & > * {\n      display: inline;\n    }\n  }\n  & > .tk-link.toggle {\n    margin-left: 8px;\n    text-decoration: none;\n    display: inline;\n  }\n  & > .tk-icon-top {\n    &::before {\n      transition: transform 300ms ease-in-out;\n    }\n    &.collapsed::before {\n      transform: rotate(180deg);\n    }\n    cursor: pointer;\n  }\n"])));
var BodyDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: hidden;\n  transition: max-height 300ms ease-in-out;\n  &.collapsed {\n    max-height: 0;\n  }\n"], ["\n  overflow: hidden;\n  transition: max-height 300ms ease-in-out;\n  &.collapsed {\n    max-height: 0;\n  }\n"])));
var ExpandableCard = function (_a) {
    var children = _a.children, className = _a.className, header = _a.header, initCollapsed = _a.initCollapsed, onToggle = _a.onToggle, rest = __rest(_a, ["children", "className", "header", "initCollapsed", "onToggle"]);
    var _b = __read(react_1.useState(initCollapsed === undefined || initCollapsed), 2), collapsed = _b[0], setCollasped = _b[1];
    var _c = __read(react_1.useState(null), 2), refEl = _c[0], setRefEl = _c[1];
    var onToggleHeader = function () {
        var reverseCollapsed = !collapsed;
        setCollasped(reverseCollapsed);
        if (onToggle) {
            onToggle(reverseCollapsed, refEl);
        }
    };
    return (React.createElement("div", __assign({ className: className, ref: setRefEl }, rest),
        React.createElement(HeaderDiv, null,
            React.createElement("div", null, header),
            "\u2022",
            React.createElement("a", { className: classnames_1.default('tk-link toggle'), onClick: onToggleHeader }, collapsed ? 'EXPAND' : 'COLLAPSE'),
            React.createElement("i", { className: classnames_1.default('tk-icon-top', { collapsed: collapsed }), onClick: onToggleHeader, "aria-label": "Toggle" })),
        React.createElement(BodyDiv, { className: classnames_1.default({ collapsed: collapsed }) }, children)));
};
ExpandableCard.propTypes = {
    initCollapsed: PropTypes.bool,
    header: PropTypes.node.isRequired,
};
ExpandableCard.defaultProps = {
    initCollapsed: true,
};
exports.default = ExpandableCard;
var templateObject_1, templateObject_2;
